import React from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';

const PREFIX = 'BackLink';

const classes = {
  back: `${PREFIX}-back`,
};

const StyledLink = styled(Link)(({ theme }) => ({
  [`&.${classes.back}`]: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    margin: theme.spacing(1),
  },
}));

export default function BackLink() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  const goBack = (evt: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    navigate(-1);
    evt.preventDefault();
  };

  return (
    <StyledLink
      color="primary"
      className={classes.back}
      href="#"
      onClick={goBack}
      underline="hover">
      <ArrowBackIos />
      {t('common.back')}
    </StyledLink>
  );
}
